import { PageHeader } from "../../../Components/Public/PageHeader/PageHeader";
import { Col, Row } from "react-bootstrap";
import React from "react";
import { ReactComponent as Data } from '../../../Images/public/aboutpsoppc/Data.svg';
import { ReactComponent as Feedback } from '../../../Images/public/aboutpsoppc/Feedback.svg';
import { ReactComponent as Security } from '../../../Images/public/aboutpsoppc/Security.svg';
import { ReactComponent as Support } from '../../../Images/public/aboutpsoppc/Support.svg';
import { ReactComponent as SupportHelp } from '../../../Images/public/aboutpsoppc/supportHelp.svg';
import { ReactComponent as SupportMail } from '../../../Images/public/aboutpsoppc/supportMail.svg';
import { ReactComponent as SupportContact } from '../../../Images/public/aboutpsoppc/supportContact.svg';
import Card from "react-bootstrap/Card";
import { PATHS } from "../../../Utils/PagePaths";

function AboutPSOPPC () {
  const headerStyle = "mb-3 mt-2 header2 font-weight-bold";
  const bodyStyle = "mt-3 mb-5 body";
  const supportMailIcon = <SupportMail />;
  const supportHelpIcon = <SupportHelp />;
  const supportContactIcon = <SupportContact />;
  const cardsArr = [
    {
      title: "Collect & Manage Data Submissions",
      body: "Support for confidential patient safety event data through Common Formats",
      icon: <Data />,
    },
    {
      title: "Ensure Data Privacy & Security",
      body: "Complies with HIPAA and Patient Safety Act requirements",
      icon: <Security />,
    },
    {
      title: "Facilitate Feedback & Communication",
      body: "Offers tools for submitting and reviewing Common Format feedback",
      icon: <Feedback />,
    },
    {
      title: "Support PSOs & Vendors",
      body: "Technical and educational support for data submission and system use",
      icon: <Support />,
    },
  ]
  return (
    <>
      <PageHeader title="About PSOPPC" />
      <Row className="justify-content-center about-psoppc text-start text-break">
        <Col xxl={8} xl={9} lg={10} md={10} sm={12} className="ps-3 pe-3 ms-3 me-3 p-5 text-start text-break">
          <h2 className={headerStyle}>Who we are</h2>
          <p className={bodyStyle}>
            The Patient Safety Organization Privacy Protection Center (PSOPPC) was created by the Agency for Healthcare Research and
            Quality (AHRQ) to support the implementation of the <a href={`https://pso.ahrq.gov/resources/act`} target={`_blank`} className={`external-link`}>Patient Safety and Quality Improvement Act of 2005</a>.
            The Patient Safety Act extends legal privilege and confidentiality protections to information voluntarily submitted by
            healthcare providers to Patient Safety Organizations (PSOs). PSOs assist health care providers in developing and implementing
            patient safety improvement strategies.</p>
          <h2 id="what-we-do" className={headerStyle}>What we do</h2>
          <p className={`mt-3 mb-2 body`}>The PSOPPC is a trusted partner in advancing patient safety by supporting the collection, management, and analysis of healthcare event data using standardized Common Formats. We help Patient Safety Organizations (PSOs) and providers comply with legal protections and securely share data with the Agency for Healthcare Research and Quality (AHRQ).</p>
          <Row className="g-3 mt-2 mb-5 public-cards text-start text-break">
            {cardsArr.map((card, idx) => (
              <Col
                key={`about-action-card-${idx}`}
                xs={12}
                sm={12}
                md={6}
                lg={4}
                xl={4}
                xxl={3}
              >
                <Card className="h-100 blue-card p-0">
                  <Card.Body className="d-flex flex-column row-gap-3 align-items-start text-start text-break">
                    {card.icon}
                    <div>
                      <h2 className="public-card-header horizontal text-start text-break header3 ">{card.title}</h2>
                      <div className="public-card-content body">
                        <p>{card.body}</p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <h2 className={headerStyle}>How we protect your data</h2>
          <p className="mt-3">
            Under the Patient Safety Act, the Network of Patient Safety Databases (NPSD) receives
            non-identifiable patient safety data submitted by Patient Safety Organizations (PSOs) for national aggregation and analysis.
            The PSOPPC supports PSOs by providing technical assistance, documentation, and guidance to help ensure submissions are
            prepared and transmitted in accordance with applicable statutory and regulatory requirements.
          </p>
          <p className={bodyStyle}>Data submitted to the NPSD are de-identified prior to receipt, securely stored, and analyzed only in
            the aggregate. The NPSD does not collect, retain, or access direct patient identifiers or identifiable Patient Safety Work
            Product (PSWP). These safeguards ensure that PSO submissions remain protected while enabling system-level learning to support
            patient safety and quality improvement efforts nationwide.
          </p>
          <h2 className={headerStyle}>Technical Assistance</h2>
          <p className={bodyStyle}>The PSOPPC will offer a broad set of technical assistance services to PSOs including:
            <ul className={`mb-1 mt-3 body`}>
              <li>Education on the format for submitting patient safety concern information to the NPSD</li>
              <li>Coordination of PSO activities including conferences and work groups</li>
              <li>Assistance on rendering patient safety data non-identifiable.</li>
            </ul>
            <p className="mt-4 mb-3 body ">If you need help, there are <strong>three ways</strong> to reach out to the PSOPPC team:</p>
            <ol className={`body`}>
              <li className={`body font-weight-bold`}>
                <h2 className={`body font-weight-bold text-black`}>Email Support</h2>
                <p className={`fw-normal`} >{supportMailIcon} : <a href="mailto:support@psoppc.org">support@psoppc.org</a></p>
              </li>
              <li className={`body font-weight-bold`}>
                <h2 className={`body font-weight-bold text-black`}>Phone Support</h2>
                <p className={`fw-normal`}>{supportContactIcon} : <a href="tel:+18665717712">(866) 571-7712</a> (Mon-Fri, 9:00 AM - 5:30 PM ET)</p>
              </li>
              <li className={`body font-weight-bold`}>
                <h2 className={`body font-weight-bold text-black`}>Online Help Center</h2>
                <p className={`fw-normal`}>{supportHelpIcon} : <a href={PATHS.public['Sign In']}>Login to submit a request to the PSOPPC Help Center</a></p>
              </li>
            </ol>
          </p>
        </Col>
      </Row>
    </>
  );
}

export default AboutPSOPPC;